import { render } from "./SelectForm.vue?vue&type=template&id=37175cd6&scoped=true&ts=true"
import script from "./SelectForm.vue?vue&type=script&lang=ts"
export * from "./SelectForm.vue?vue&type=script&lang=ts"

import "./SelectForm.vue?vue&type=style&index=0&id=37175cd6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37175cd6"],['__file',"src/components/inputs/form/SelectForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37175cd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37175cd6', __exports__)) {
    api.reload('37175cd6', __exports__)
  }
  
  module.hot.accept("./SelectForm.vue?vue&type=template&id=37175cd6&scoped=true&ts=true", () => {
    api.rerender('37175cd6', render)
  })

}


export default __exports__